import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { TagComponent } from '../../../core/labels/tag.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import {
  LocalResponse,
  OtherResponse,
  PayrollFullDashboardResponse,
  PayrollResponse,
  StateResponse,
} from '../../../../models/api/view/claim/hr/payroll/payroll-full-dashboard-response';
import { ClaimKey } from '../../../../models/api/core/claim-key';
import { FormatPipe } from '../../../../pipes/format.pipe';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  imports: [
    RouterModule,
    DetailPanelComponent,
    DetailItemComponent,
    PageHeaderComponent,
    TagComponent,
    CardComponent,
    FormatPipe,
  ],
  template: `
    <app-page-header label="Taxes" />
    <div class="tw-flex tw-gap-6 tw-px-4">
      <div class="tw-basis-2/5">
        <app-card label="federal">
          <app-detail-panel [dataSource]="payroll">
            <app-detail-item label="tax Status" name="taxStatus" />
            <app-detail-item
              label="federal Exemption"
              name="federalExemption"
            />
            <app-detail-item
              label="additional Fed Exempt"
              name="additionalFedExempt"
            />
            <app-detail-item
              label="fixed Federal Withholding"
              name="fixedFederalWithHolding"
              format="b"
            />
            <app-detail-item
              label="Additional withholding %"
              name="percentage"
            />
          </app-detail-panel>
        </app-card>

        <div class="tw-pt-8"></div>

        <app-card label="other">
          <app-detail-panel [dataSource]="other">
            <app-detail-item
              label="school District Tax"
              name="schoolDistrictTax"
            />
            <app-detail-item
              label="SUI/SDI tax block"
              labelCase="none"
              name="suiSdiTaxBlock"
              format="b"
            />
            <app-detail-item
              label="EIC status"
              labelCase="none"
              name="eicStatus"
            />
            <app-detail-item
              label="qualified Pension"
              name="qualifiedPension"
              format="b"
            />
            <app-detail-item
              label="SS/Medicare block"
              labelCase="none"
              name="ssMedicareBlock"
              format="b"
            />
            <app-detail-item
              label="school District Tax Block"
              name="schoolDistrictTaxBlock"
              format="b"
            />
            <app-detail-item
              label="SUI tax code"
              labelCase="none"
              name="suiTaxCode"
            />
            <app-detail-item label="EIC year" labelCase="none" name="eicYear" />
            <app-detail-item
              label="state Reciprocity"
              name="stateReciprocity"
            />
            <app-detail-item
              label="household Employee"
              name="householdEmployees"
              format="b"
            />
          </app-detail-panel>
        </app-card>
      </div>
      <div class="tw-basis-3/5">
        <app-card label="state and local">
          <div class="tw-grid tw-pt-1 tw-gap-1.5 tw-items-center ">
            <div></div>
            <div class="tw-font-bold tw-text-right tw-pr-2">Work state</div>
            <div class="tw-font-bold tw-text-right tw-pr-2">
              Residence state
            </div>
            <div class="tw-font-bold tw-text-right tw-pr-2">Local 1</div>
            <div class="tw-font-bold tw-text-right tw-pr-2">Local 2</div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Tax status</div>
            <div class="tw-text-right tw-pr-2">{{ state?.taxStatusWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.taxStatus }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.taxStatusLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.taxStatusLocal2 }}
            </div>
            <div class="tw-border-b  tw-col-span-5"></div>

            <div class="tw-font-bold">Tax state</div>
            <div class="tw-text-right tw-pr-2">{{ state?.taxStateWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.taxState }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.taxStateLocal1 }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.taxStateLocal2 }}</div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Residency</div>
            <div class="tw-text-right tw-pr-2">{{ state?.residencyWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.residency }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.residencyLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.residencyLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Non-residency tax %</div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.nonResidentTaxWork }}
            </div>
            <div class="tw-text-right tw-pr-2">{{ state?.nonResidentTax }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.nonResidentTaxLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.nonResidentTaxLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">State exempt</div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.stateExemptWork }}
            </div>
            <div class="tw-text-right tw-pr-2">{{ state?.stateExempt }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.stateExemptLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.stateExemptLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Add'l state exempt</div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.addStateExemptWork }}
            </div>
            <div class="tw-text-right tw-pr-2">{{ state?.addStateExempt }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.addStateExemptLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.addStateExemptLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Client code</div>
            <div class="tw-text-right tw-pr-2">{{ state?.clientCodeWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.clientCode }}</div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.clientCodeLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.clientCodeLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Fixed state withholding</div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.fixedStateWithholdingWork ? 'Yes' : 'No' }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.fixedStateWithholding ? 'Yes' : 'No' }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.fixedStateWithholdingLocal1 ? 'Yes' : 'No' }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.fixedStateWithholdingLocal2 ? 'Yes' : 'No' }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Exempt $</div>
            <div class="tw-text-right tw-pr-2">{{ state?.exemptWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.exempt }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.exemptLocal1 }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.exemptLocal2 }}</div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Exempt %</div>
            <div class="tw-text-right tw-pr-2">{{ state?.percentWork }}</div>
            <div class="tw-text-right tw-pr-2">{{ state?.percent }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.percentLocal1 }}</div>
            <div class="tw-text-right tw-pr-2">{{ local?.percentLocal2 }}</div>
            <div class="tw-border-b tw-col-span-5"></div>

            <div class="tw-font-bold">Federal withholding %</div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.ofFederalWithholdingWork }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ state?.ofFederalWithholding }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.ofFederalWithholdingLocal1 }}
            </div>
            <div class="tw-text-right tw-pr-2">
              {{ local?.ofFederalWithholdingLocal2 }}
            </div>
            <div class="tw-border-b tw-col-span-5"></div>
          </div>
        </app-card>
      </div>
      <div class="tw-basis-1/4"></div>
    </div>
    <div class="tw-pt-8"></div>
    <app-page-header label="Payroll" />
    <div class="tw-flex tw-gap-6  tw-px-4">
      <div class="tw-basis-2/5">
        <app-card label="pay">
          <app-detail-panel [dataSource]="payroll">
            <app-detail-item label="last Paid" name="lastPaid" format="d" />
            <app-detail-item label="frozen Flex" name="frozenFlex" format="b" />
            <app-detail-item label="direct Deposit" name="directDeposit">
              <ng-template #value let-data>
                @if (data.directDeposit) {
                  <app-tag type="Success">Enrolled</app-tag>
                } @else {
                  <app-tag type="Warn">Not enrolled</app-tag>
                }
              </ng-template>
            </app-detail-item>
            <app-detail-item label="Account type" name="accountType" />
            <app-detail-item label="Bank name" name="bankName" />
          </app-detail-panel>
        </app-card>
      </div>
      <div class="tw-basis-3/5">
        <app-card label="buy up">
          <div
            class="tw-grid tw-pt-1 tw-grid-cols-[40%_30%_30%] tw-gap-1.5 tw-items-center "
          >
            <div></div>
            <div class="tw-font-bold">STD</div>
            <div class="tw-font-bold">LTD</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Buy up</div>
            <div>{{ payroll?.buyUpSTD ? 'Yes' : 'No' }}</div>
            <div>{{ payroll?.buyUpLTD ? 'Yes' : 'No' }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Effective</div>
            <div>{{ payroll?.effectiveSTD | format: 'd' }}</div>
            <div>{{ payroll?.effectiveLTD | format: 'd' }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Buy up effective</div>
            <div>{{ payroll?.buyUpEffectiveSTD | format: 'd' }}</div>
            <div>{{ payroll?.buyUpEffectiveLTD | format: 'd' }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Employee contrib %</div>
            <div>{{ payroll?.employeeContribSTD }}</div>
            <div>{{ payroll?.employeeContribLTD }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Employer contrib %</div>
            <div>{{ payroll?.employerContribSTD }}</div>
            <div>{{ payroll?.employerContribLTD }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Post-tax contrib %</div>
            <div>{{ payroll?.postTaxContribSTD }}</div>
            <div>{{ payroll?.postTaxContribLTD }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>

            <div class="tw-font-bold">Pre-tax contrib %</div>
            <div>{{ payroll?.preTaxContribSTD }}</div>
            <div>{{ payroll?.preTaxContribLTD }}</div>
            <div class="tw-border-b  tw-col-span-3"></div>
          </div>
        </app-card>
      </div>
    </div>
  `,
  styles: ``,
})
export class PayrollComponent extends BaseComponent implements OnInit {
  claim = this.view.currentClaim();
  payroll: PayrollResponse;
  local: LocalResponse;
  other: OtherResponse;
  state: StateResponse;

  payrollDashboard: PayrollFullDashboardResponse;

  loading = false;

  @HandleLoadingState({ useViewLoading: true })
  async ngOnInit() {
    const claimKey: ClaimKey = {
      recordId: this.claim.recordId,
      recordSource: this.claim.recordSource,
    };
    await this.api.payrollController.get(claimKey).then((payrollDashboard) => {
      this.payroll = payrollDashboard.payroll;
      this.local = payrollDashboard.local;
      this.other = payrollDashboard.other;
      this.state = payrollDashboard.state;
    });
  }
}
